// ─── Opening the Academy · without its content (sprint 13, 6.2) ─────────────
// The calendar, the index panel and "מושג השבוע" link into lessons. They need
// to open one, not to carry the 360KB of lesson text: this module holds only
// the rule for which lessons are shown and the hand-off to the Academy. The
// content (utils/academy.js, data/academyContent.json) loads with the Academy.
import { LESSON_6_2_ENABLED } from "../constants/features";

// Lessons held back until counsel approves them (constants/features.js).
const HIDDEN_LESSONS = new Set(LESSON_6_2_ENABLED ? [] : ["6.2"]);
export const isLessonShown = id => !HIDDEN_LESSONS.has(id);

// A lesson id as the content names them: track 1–7, then the lesson.
const LESSON_ID = /^[1-7]\.\d{1,2}$/;

// The lesson id waits here until AcademyTab takes it: on mount (a phone opens
// a fresh overlay) or on the event (a desktop tab already open). A hidden
// lesson (6.2) opens the front page instead; AcademyTab also ignores an id
// the content does not have.
let pendingLesson = null;
export function openAcademyLesson(id) {
  pendingLesson = id && LESSON_ID.test(id) && isLessonShown(id) ? id : null;
  window.dispatchEvent(new CustomEvent("si-open-academy", { detail: { lesson: pendingLesson } }));
}
export function takePendingLesson() {
  const id = pendingLesson;
  pendingLesson = null;
  return id;
}
